import { render, staticRenderFns } from "./PercentageIndicator.vue?vue&type=template&id=3cbe1854&scoped=true"
import script from "./PercentageIndicator.vue?vue&type=script&lang=js"
export * from "./PercentageIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe1854",
  null
  
)

export default component.exports